import { memo, useMemo } from 'react';

import NotFound from 'components/NotFound';

import CustomForm from '../../../components/forms/Custom/CustomForm';

const ChatRow = ({ item, components, customCN, setCustomCN = false, isScrolling }) => {
  const Input = useMemo(() => {
    return item?.forms || CustomForm || NotFound;
  }, [item?.forms]);

  return (
    <div
      key={`${item.key}-${item.type}`}
      id={item?.title}
      className="rounded-md border border-solid border-neutral-100">
      <Input
        inputName={item.path}
        type={item?.type || item?.key}
        components={components}
        customCN={customCN}
        setCustomCN={setCustomCN}
        isScrolling={isScrolling}
      />
    </div>
  );
};

export default memo(ChatRow);
